import React, {useState, useEffect} from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "../components/SignInModal.scss";

const SignInModal = ({handleSignIn,handleSignInLater,setShowModal}) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    if (isButtonDisabled) {
      const timer = setTimeout(() => {
        setIsButtonDisabled(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isButtonDisabled]);

  return (
    <div className="modalCustom">
      <div className="modalCustomContent">
        <span className="customClose" onClick={() =>{setShowModal(false)}}>
          <HighlightOffIcon />
        </span>
        <div className="btnSignLateModal">
          <button onClick={() => {handleSignIn()}}>Sign Now</button>
          <button onClick={() => {setIsButtonDisabled(true); handleSignInLater(); }} disabled={isButtonDisabled}>Sign Later</button>
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
